import { destroyCookie, parseCookies, setCookie } from "nookies";
import { LOCALSTORAGEFIELDS } from "@/constants";
import { getTokenExpiresDuration } from "./tokenService";

const getSecureCookieOptions = () => {
  const options = {
    path: "/",
    sameSite: "Strict",
    secure: true,
  };

  if (process.env.NODE_ENV === "development") {
    options.secure = false;
    options.sameSite = "Lax";
  }

  return options;
};

const cookiesService = (function () {
  let _service;

  function _getService() {
    if (!_service) {
      _service = this;
      return _service;
    }
    return _service;
  }

  function _setToken(tokenObj) {
    const cookieOptions = getSecureCookieOptions();
    if (tokenObj?.access) {
      setCookie(null, LOCALSTORAGEFIELDS.accessToken, tokenObj.access, {
        ...cookieOptions,
        maxAge: getTokenExpiresDuration(tokenObj.access),
      });
    }
    if (tokenObj?.refresh) {
      setCookie(null, LOCALSTORAGEFIELDS.refreshToken, tokenObj.refresh, {
        ...cookieOptions,
        maxAge: getTokenExpiresDuration(tokenObj.refresh),
      });
    }
  }

  function _getAccessToken() {
    try {
      const cookies = parseCookies(null);
      const token = cookies[LOCALSTORAGEFIELDS.accessToken];
      return token && _validateToken(token) ? token : "";
    } catch (e) {
      console.error("Error getting access token:", e);
      return "";
    }
  }

  function _getRefreshToken() {
    try {
      const cookies = parseCookies(null);
      const token = cookies[LOCALSTORAGEFIELDS.refreshToken];
      return token && _validateToken(token) ? token : "";
    } catch (e) {
      console.error("Error getting refresh token:", e);
      return "";
    }
  }

  function _clearToken(ctx = null) {
    const cookieOptions = getSecureCookieOptions();
    destroyCookie(ctx, LOCALSTORAGEFIELDS.accessToken, cookieOptions);
    destroyCookie(ctx, LOCALSTORAGEFIELDS.refreshToken, cookieOptions);
  }

  function _validateToken(token) {
    if (!token) return false;
    const tokenParts = token.split(".");
    if (tokenParts.length !== 3) return false;
    try {
      return tokenParts.every((part) => {
        return /^[A-Za-z0-9_-]+$/i.test(part);
      });
    } catch (e) {
      console.error("Error validating token:", e);
      return false;
    }
  }

  return {
    getService: _getService,
    setToken: _setToken,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    clearToken: _clearToken,
    validateToken: _validateToken,
    getSecureCookieOptions: getSecureCookieOptions,
  };
})();

export default cookiesService;
